import { EmailTemplate } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

const formSlice = createGenericFormSlice({
  name: "createEmailTemplate",
  initialState: {} as SliceState<EmailTemplate>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const createEmailTemplateReducer = formSlice.reducer;
export default createEmailTemplateReducer;
